import apiClient from "./apiClient";

export const getExecutiveRiskDashboard = (params = {}) =>
  apiClient.get("/risk-dashboard/executive", { params });

export const getRiskDashboardTrends = (params = {}) =>
  apiClient.get("/risk-dashboard/trends", { params });

export const getRiskDashboardTop = (params = {}) =>
  apiClient.get("/risk-dashboard/top", { params });
